import { Link } from '@mui/material';
import StyledLoginFooter, {
  LearnMoreButton,
  StyledText
} from './LoginFooter.style';

const LoginFooter = () => (
  <StyledLoginFooter>
    <StyledText>Don't have gitStream?</StyledText>
    <LearnMoreButton
      LinkComponent={Link}
      href='https://docs.gitstream.cm/'
      target='_blank'
      variant='contained'
    >
      Learn more
    </LearnMoreButton>
  </StyledLoginFooter>
);

export default LoginFooter;
